import {CustomerCategoryDao} from '../../dao';
import {CustomerCategoryModel} from '../../models';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'UPDATE_CUSTOMER_CATEGORY_BY_ID';

export async function updateCustomerCategoryById(
    userData: Record<string, string>,
    customerCategoryId: number,
    update: Record<string, any>
) {
    try {
        const result = await CustomerCategoryDao.updateCustomerCategoryById(userData.userToken, customerCategoryId, update);

        const resultParsed = CustomerCategoryModel.parseCustomerCategory(result);

        return resultParsed;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
